module.exports = __webpack_public_path__ + "img/图片17.e1917c65.jpg";